// src/pages/GramParentDashboard.tsx
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

import MomPage from "../MomPage";
import GramDashboard1 from "./GramDashboard1";
import GramDashboard2 from "./GramDashboard2";
import GramDashboard3 from "./GramDashboard3";
import GramDashboard4 from "./GramDashboard4";
// import GramDashboard2 from "./GramDashboard2";
// import GramDashboard3 from "./GramDashboard3";

interface ParentProps {
    finYear: string;
    meetingType: any;
}

const GramParentDashboard: React.FC<ParentProps> = ({ finYear, meetingType }) => {
    const gramData = useSelector(
        (state: RootState) => state.common.dashboardData["Gram Panchayats"]
    );

    const isStateSelected =
        gramData?.state_code !== null && gramData?.state_name !== "";
    const isZpSelected =
        gramData?.zp_lgd_code !== null && gramData?.zp_name !== "";
    const isBpSelected =
        gramData?.bp_lgd_code !== null && gramData?.bp_name !== "";
    const isGpSelected =
        gramData?.gp_lgd_code !== null && gramData?.gp_name !== "";
    console.log("GRAM DATA:", gramData);
    const ONE_TIER_STATES = [13, 15]; // Mizoram, Nagaland
    const BP_DIRECT_STATES = [34]; // Puducherry
    const stateCode = Number(gramData?.state_code);

    const isOneTierState = ONE_TIER_STATES.includes(stateCode);
    const isBpDirectState = BP_DIRECT_STATES.includes(stateCode);

return (
  <>
    {!isStateSelected ? (
      <GramDashboard1 finYear={finYear} meetingType={meetingType} />
    ) : isOneTierState ? (
      // ✅ Only for Mizoram/Nagaland
      !isGpSelected ? (
        <GramDashboard2 finYear={finYear} meetingType={meetingType} />
      ) : (
        <MomPage finYear={finYear} meetingType={meetingType} />
      )
    ) : isBpDirectState ? (
      !isBpSelected ? (
        <GramDashboard2 finYear={finYear} meetingType={meetingType} />
      ) : !isGpSelected ? (
        <GramDashboard4 finYear={finYear} meetingType={meetingType} />
      ) : (
        <MomPage finYear={finYear} meetingType={meetingType} />
      )
    ) : !isZpSelected ? (
      <GramDashboard2 finYear={finYear} meetingType={meetingType} />
    ) : !isBpSelected ? (
      <GramDashboard3 finYear={finYear} meetingType={meetingType} />
    ) : !isGpSelected ? (
      <GramDashboard4 finYear={finYear} meetingType={meetingType} />
    ) : (
      <MomPage finYear={finYear} meetingType={meetingType} />
    )}
  </>
);
};

export default GramParentDashboard;
